import React from "react";
import MuiDialogTitle from "@mui/material/DialogTitle";
import TextField from "../Form/TextFieldV2/TextFieldV2";
import * as S from "../../constants/StringConstants";

import "./NewNoteForm.scss";

interface RouteParams {
  isEdit?: boolean;
}

const NewNoteForm: React.FC<RouteParams> = ({ isEdit }) => {
  const required = (value: string) => (value ? undefined : S.FORM_FIELD_REQUIRED);

  return (
    <div className="new-note__wrap">
      <MuiDialogTitle className="new-note__dialog-title">
        {isEdit ? S.PC_EDIT_PROPOSAL_NOTE : S.PC_ADD_PROPOSAL_NOTE}
      </MuiDialogTitle>
      <div className="new-note__title">
        <TextField name="title" validate={required} />
      </div>
      <div className="new-note__description">
        <TextField name="description" validate={required} multiline />
      </div>
    </div>
  );
};

export default NewNoteForm;
